/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { Flag } from 'ui/atoms/Flag/Flag';

import styles from './AuthorityBand.module.scss';

interface AuthorityItem {
  country: string;
  flag: string;
  name: string;
}

const AUTHORITIES: AuthorityItem[] = [
  { country: 'us', flag: 'us', name: 'Internal Revenue Service' },
  { country: 'us', flag: 'us', name: 'Delaware Division of Corporations' },
  { country: 'de', flag: 'de', name: 'Bundeszentralamt für Steuern' },
  { country: 'gb', flag: 'gb', name: 'HM Revenue & Customs' },
  { country: 'it', flag: 'it', name: 'Agenzia delle Entrate' },
  { country: 'es', flag: 'es', name: 'Agencia Tributaria' },
  { country: 'nl', flag: 'nl', name: 'Belastingdienst' },
  { country: 'fr', flag: 'fr', name: 'Direction générale des Finances publiques' },
  { country: 'se', flag: 'se', name: 'Skatteverket' },
  { country: 'au', flag: 'au', name: 'Australian Business Register' },
  { country: 'br', flag: 'br', name: 'Receita Federal' },
  { country: 'in', flag: 'in', name: 'Goods and Services Tax Network' },
  { country: 'no', flag: 'no', name: 'Brønnøysundregistrene' },
  { country: 'gb', flag: 'gb', name: 'Companies House' },
  { country: 'de', flag: 'de', name: 'Handelsregister' },
  { country: 'nl', flag: 'nl', name: 'KVK' },
];

export const AuthorityBand = () => {
  const { t } = useInt();
  const track = [...AUTHORITIES, ...AUTHORITIES];

  return (
    <section className={styles.band}>
      <div className={styles.inner}>
        <div className={styles.label}>
          <span className={styles.liveDot} />
          {t('Checked against')}
        </div>

        <div className={styles.list}>
          <div className={styles.track}>
            {track.map((item, i) => (
              <span key={`${item.name}-${i}`} className={styles.item}>
                <Flag code={item.flag} className={styles.flag} rounded />
                {item.name}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
